export const totalRow = (product) => (
  (parseFloat(product.price || 0) * parseInt(product.quantity || 0, 10)).toFixed(2)
);


